import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SparepartService } from '../services/sparepart.service';
import { SpareInOut } from '../models/spareinout';
import { SpareInOutService } from '../service/spare-in-out.service';


let ELEMENT_DATA = [];

@Component({
  selector: 'app-item-check',
  templateUrl: './item-check.component.html',
  styleUrls: ['./item-check.component.scss']
})
export class ItemCheckComponent implements OnInit {

  ELEMENT_DATA: any[];
  items: any;
  displayedColumns: string[] = ['from','to', 'item', 'qty', 'type','engine','powertrain', 'reason', 'created'];
  dataSource = new MatTableDataSource();
  resource: SpareInOut = new SpareInOut();
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private service: SpareInOutService,
    private spService: SparepartService,
  ) { }

  ngOnInit() {
    //this.getResources();
    this.getItems();
  }

  onItemSelect(item: string) {
    if(!item){
      this.updateDataSource(ELEMENT_DATA);
      return;
    }

    let arr = [];
    for (let obj of ELEMENT_DATA) {
      if (obj.item == item) {
        arr.push(obj);
      }
    }
    this.updateDataSource(arr);
  }

  getItems() {
    this.items = [];
    this.spService.getAll()
      .subscribe(result => {
        this.items = this.items.concat(result);
      })
  }

  updateDataSource(arr: any) {
    this.dataSource = new MatTableDataSource<any>(arr);
    this.dataSource.paginator = this.paginator;
  }

  // getResources() {
  //   ELEMENT_DATA = [];
  //   this.service.getAllResources()
  //     .subscribe(result => {
  //       ELEMENT_DATA = ELEMENT_DATA.concat(result);
  //       this.updateDataSource(ELEMENT_DATA);
  //     })
  // }


}
